import {h, Fragment} from "preact"
import { useAppState, AutocompleteElement, HistoryElement } from '@nosto/preact'
import { useEffect, useRef } from 'preact/hooks'
import { defaultConfig, popularSearchTerms, isFrench } from '../config'
import { formatCurrency, getProductByHandle } from '../helpers'
import AutocompleteProduct from './AutocompleteProduct'

export default () => {
    const { response: { products }, } = useAppState()
    const autocomRef = useRef(null);
    const backdropRef = useRef(null);

    if (!products?.hits?.length) {
        return
    }

    useEffect(() => {
        const handleScroll = () => {  
            let position = '';       
            if (window.innerWidth <= 1023 && window.scrollY > 0) {
                window.scrollY < 35
                    ?   position = (64 + (35 - window.scrollY)) + 'px'
                    :   position = '64px'
            } else if (window.innerWidth >= 1024 && window.scrollY > 0) {
                window.scrollY < 45
                    ?   position = (75 + (45 - window.scrollY)) + 'px'
                    :   position = '75px'
            }
            if(autocomRef.current) {
                autocomRef.current.style.top = position;
            }
            if(backdropRef.current) {
                backdropRef.current.style.top = position;
            }
        }
        handleScroll();
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])

    const closeAutocomplete = () => {
        if(document.querySelector('section[data-section="header"]')) {
            document.querySelector('section[data-section="header"]').click();
        }
    }

    const addToCart = (product) => {
        const handle = product.url.split('/products/')[1];
        window.globalAddToCart({ handle, variantId: product.skus[0].id })
        // trackClick("serp", products);
    }

    return (
        <>
            <div class="ns-autocomplete fixed" data-nosto-element="autocomplete" ref={autocomRef}>
                <div class="ns-ac-content flex">
                    <div class="ns-popularsearches-wrapper">
                        <div class="ns-popularsearches-title">{isFrench ? 'Recherches Populaires' : 'Popular Searches'}</div>
                        <div class="ns-popularsearches-container flex flex-row">
                            {popularSearchTerms.en.length > 0 && popularSearchTerms.fr.length > 0 && (
                                isFrench
                                    ? popularSearchTerms.fr.map((term) => (
                                        <HistoryElement query={{ query: term }} key={term}>
                                            <button className="ns-popular-search" type="button">{term}</button>
                                        </HistoryElement>
                                    ))
                                    : popularSearchTerms.en.map((term) => (
                                        <HistoryElement query={{ query: term }} key={term}>
                                            <button className="ns-popular-search" type="button">{term}</button>
                                        </HistoryElement>
                                    ))
                            )}
                        </div>
                    </div>
                    <div class="ns-ac-product-container flex flex-wrap">
                        {products?.hits
                            ?.slice(0, defaultConfig.autocompleteSize)
                            ?.map((hit) => (
                                <AutocompleteProduct 
                                    key={hit.productId} 
                                    product={hit} 
                                    addToCart={addToCart} 
                                />
                            ))}
                    </div>
                </div>
            </div>
            <div class="ns-autocomplete-backdrop fixed" onClick={closeAutocomplete} ref={backdropRef} />
        </>
    )
}
